<!-- Popup Mode Box Container -->
<div
  *ngIf="mode === 'popup'"
  class="fixed sm:absolute w-[calc(100%-2rem)] max-w-full sm:w-[25rem] top-16 sm:top-12 left-4 right-4 sm:left-auto sm:right-0 z-50 font-sans mx-auto sm:mx-0"
>
  <div
    *ngIf="isVisible"
    class="bg-[#111622] border border-slate-800/90 text-white p-4 rounded-2xl shadow-2xl relative flex flex-col w-full"
  >
    <!-- Header bar styling configuration details -->
    <div class="flex justify-between items-center mb-4 px-1">
      <div class="flex items-center gap-2.5 min-w-0">
        <span class="text-white text-base sm:text-xl flex-shrink-0">🔔</span>
        <div class="min-w-0">
          <h3
            class="text-sm sm:text-lg font-black text-white italic tracking-tight truncate"
          >
            Notifications
          </h3>
          <p
            class="text-[8px] text-slate-600 font-bold uppercase tracking-widest mt-0.5"
          >
            Signal feed
          </p>
        </div>
        <span
          *ngIf="unreadCount > 0"
          id="notif-badge-header"
          class="min-w-[18px] h-[18px] px-1.5 flex items-center justify-center bg-[#F5CF6B] text-[#0A0F1D] text-[10px] font-black rounded-full flex-shrink-0"
        >
          {{ unreadCount > 99 ? "99+" : unreadCount }}
        </span>
      </div>
      <button
        (click)="mode = 'fullpage'"
        class="text-[10px] font-bold text-slate-400 hover:text-white tracking-widest uppercase transition-colors flex-shrink-0 ml-2"
      >
        View All
      </button>
    </div>

    <!-- Active tabs state selector bar -->
    <div class="flex border-b border-slate-800/80 mb-4 relative">
      <button
        (click)="switchTab('unread')"
        class="w-1/2 py-2 text-xs font-black tracking-widest uppercase text-center relative transition-colors"
        [ngClass]="activeTab === 'unread' ? 'text-[#F5CF6B]' : 'text-slate-500'"
      >
        Unread ({{ unreadCount }})
        <div
          *ngIf="activeTab === 'unread'"
          class="absolute bottom-0 left-0 right-0 h-[2px] bg-[#F5CF6B] shadow-[0_0_8px_#F5CF6B]"
        ></div>
      </button>
      <button
        (click)="switchTab('read')"
        class="w-1/2 py-2 text-xs font-black tracking-widest uppercase text-center relative transition-colors"
        [ngClass]="activeTab === 'read' ? 'text-[#F5CF6B]' : 'text-slate-500'"
      >
        Read ({{ readCount }})
        <div
          *ngIf="activeTab === 'read'"
          class="absolute bottom-0 left-0 right-0 h-[2px] bg-[#F5CF6B] shadow-[0_0_8px_#ffbe3b]"
        ></div>
      </button>
    </div>

    <!-- Action controllers grid row setup -->
    <div class="flex justify-end mb-3 px-1">
      <button
        *ngIf="activeTab === 'unread' && unreadCount > 0"
        (click)="markAllNotificationsAsRead()"
        class="text-[10px] font-black text-[#F5CF6B] hover:text-[#e0a52e] uppercase tracking-wider flex items-center gap-1 transition-colors"
      >
        ✓ Mark all as read
      </button>
    </div>

    <!-- Inner Scroll List feed context wrapper -->
    <div
      #scrollContainer
      class="max-h-[50vh] sm:max-h-[360px] overflow-y-auto custom-scrollbar p-1 space-y-1.5 sm:space-y-2 w-full"
    >
      <div *ngIf="filteredNotifications.length === 0" class="space-y-2.5">
        <div
          class="py-16 sm:py-20 flex flex-col items-center gap-3 text-center"
        >
          <div
            class="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-slate-800/60 border border-slate-700/50 flex items-center justify-center text-2xl sm:text-3xl"
          >
            ✅
          </div>
          <p class="text-slate-400 text-sm font-bold">All caught up!</p>
          <p class="text-slate-600 text-xs">
            No {{ activeTab }} notifications.
          </p>
        </div>
      </div>

      <div
        *ngIf="filteredNotifications.length > 0"
        class="space-y-1.5 sm:space-y-2"
      >
        <div
          *ngFor="let item of filteredNotifications; let i = index"
          (click)="onNotificationClick(item)"
          [ngClass]="
            activeTab === 'unread'
              ? 'bg-[#e7b53f0d] relative before:absolute before:left-0 before:top-0 before:bottom-0 before:w-[4px] sm:before:w-[6px] before:bg-[#e7b53f] before:rounded-l-xl hover:bg-[#e7b53f1c]'
              : 'hover:bg-white/5 border border-transparent hover:border-slate-800'
          "
          class="p-3 sm:p-4 rounded-xl sm:rounded-2xl flex items-center justify-between gap-3 group cursor-pointer transition-all overflow-hidden w-full min-w-0"
        >
          <div
            class="flex items-center space-x-3 min-w-0 pointer-events-none flex-1"
          >
            <div
              class="w-8 h-8 sm:w-10 sm:h-10 bg-[#0a0f1d] border border-slate-800 rounded-xl flex items-center justify-center flex-shrink-0 text-slate-400 group-hover:text-white transition-colors"
            >
              <span class="text-sm sm:text-lg">{{
                getNotificationIcon(item.Type)
              }}</span>
            </div>
            <div class="min-w-0 flex-1">
              <h4 class="text-xs font-black text-white italic truncate">
                {{ item.Type }}
              </h4>
              <p
                [ngClass]="
                  activeTab === 'unread' ? 'text-slate-400' : 'text-slate-500'
                "
                class="text-[10px] truncate"
              >
                {{ item.Notifications }}
              </p>
            </div>
          </div>
          <span
            [ngClass]="
              activeTab === 'unread'
                ? 'text-slate-400 font-extrabold'
                : 'text-slate-600'
            "
            class="text-[9px] font-bold uppercase flex-shrink-0 whitespace-nowrap pointer-events-none"
          >
            {{ getDaysAgo(item.AddedDate) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Bottom Action Footer Button View controller -->
    <div class="mt-4">
      <button
        (click)="mode = 'fullpage'"
        class="block w-full py-2.5 sm:py-3 bg-[#1e2330]/50 hover:bg-slate-800 border border-slate-800 rounded-xl sm:rounded-2xl text-[9px] sm:text-[10px] font-black text-[#F5CF6B] uppercase tracking-[0.2em] transition-all text-center"
      >
        View All Notifications
      </button>
    </div>
  </div>
</div>

<!-- Fullpage Layout Feed View block screen canvas setup -->
<div
  *ngIf="mode === 'fullpage'"
  class="fixed inset-0 w-screen h-screen bg-[#070a12] text-white p-4 sm:p-6 overflow-y-auto z-[9999] font-sans flex flex-col select-none animate-fade-in"
>
  <div class="max-w-4xl w-full mx-auto flex flex-col flex-grow">
    <div
      class="flex justify-between items-center mb-6 sm:mb-8 flex-shrink-0 gap-4"
    >
      <div class="flex items-center gap-2.5 min-w-0">
        <div
          class="w-9 h-9 rounded-xl bg-gold-500/10 border border-gold-500/20 flex items-center justify-center flex-shrink-0"
        >
          <svg
            class="w-4 h-4 text-[#ffbe3b]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            ></path>
          </svg>
        </div>
        <div class="min-w-0">
          <h1
            class="text-base sm:text-lg font-black text-white uppercase tracking-tight italic leading-none truncate"
          >
            Notifications
          </h1>
          <p
            class="text-[8px] text-slate-600 font-bold uppercase tracking-widest mt-0.5"
          >
            Signal feed
          </p>
        </div>
      </div>
      <button
        (click)="mode = 'popup'"
        class="text-[9px] sm:text-[10px] font-black uppercase tracking-widest bg-[#121824] border border-slate-800 hover:border-slate-700 px-3 py-2 sm:px-4 sm:py-2.5 rounded-xl text-slate-400 hover:text-white transition-all flex-shrink-0"
      >
        ← Close Feed
      </button>
    </div>

    <!-- Active view switch controllers split pane tab triggers layout -->
    <div
      class="grid grid-cols-2 gap-2 sm:gap-4 bg-[#111622] p-1.5 rounded-xl border border-slate-800/50 mb-6 flex-shrink-0"
    >
      <button
        (click)="switchTab('unread')"
        [ngClass]="
          activeTab === 'unread'
            ? 'bg-[#192032] text-[#ffbe3b] border-slate-700/80'
            : 'text-slate-500 border-transparent hover:text-slate-300'
        "
        class="flex items-center justify-center gap-1.5 sm:gap-2 py-2.5 rounded-lg font-bold uppercase tracking-wider text-[10px] sm:text-[11px] transition-all border shadow-sm"
      >
        <i class="far fa-envelope text-xs"></i> Unread
        <span
          class="px-1.5 py-0.5 text-[8px] sm:text-[9px] bg-black/40 rounded-full text-[#ffbe3b] font-black"
          >{{ unreadCount }}</span
        >
      </button>
      <button
        (click)="switchTab('read')"
        [ngClass]="
          activeTab === 'read'
            ? 'bg-[#192032] text-[#ffbe3b] border-slate-700/80'
            : 'text-slate-500 border-transparent hover:text-slate-300'
        "
        class="flex items-center justify-center gap-1.5 sm:gap-2 py-2.5 rounded-lg font-bold uppercase tracking-wider text-[10px] sm:text-[11px] transition-all border shadow-sm"
      >
        <i class="far fa-check-circle text-xs"></i> Read
        <span
          class="px-1.5 py-0.5 text-[8px] sm:text-[9px] bg-black/40 rounded-full font-black text-slate-400"
          >{{ readCount }}</span
        >
      </button>
    </div>

    <!-- Card list content box layout rules template engine logic structure mapping -->
    <div
      #scrollContainer
      class="flex-grow overflow-y-auto custom-scrollbar pr-1 w-full"
    >
      <div *ngIf="filteredNotifications.length === 0" class="space-y-2.5">
        <div class="py-20 flex flex-col items-center gap-3 text-center">
          <div
            class="w-16 h-16 rounded-2xl bg-slate-800/60 border border-slate-700/50 flex items-center justify-center text-3xl"
          >
            ✅
          </div>
          <p class="text-slate-400 text-sm font-bold">All caught up!</p>
          <p class="text-slate-600 text-xs">
            No {{ activeTab }} notifications found.
          </p>
        </div>
      </div>

      <div *ngIf="filteredNotifications.length > 0" class="space-y-2.5 w-full">
        <div
          *ngFor="let item of filteredNotifications; let i = index"
          (click)="onNotificationClick(item)"
          class="notif-card notif-animate p-3 sm:p-4 rounded-xl flex items-start gap-3 transition-all duration-200 border w-full min-w-0"
          style="
            background: rgba(10, 15, 29, 0.6);
            border-color: rgba(51, 65, 85, 0.3);
          "
        >
          <div
            class="flex-shrink-0 w-8 h-8 rounded-xl flex items-center justify-center text-sm bg-[#1e2330]/80 border border-slate-700/40"
          >
            {{ getNotificationIcon(item.Type) }}
          </div>

          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-2 mb-1">
              <span
                class="text-[8px] font-black uppercase tracking-widest text-slate-400 truncate"
              >
                {{ item.Type }}
              </span>
              <span
                class="text-[8px] text-slate-500 whitespace-nowrap flex-shrink-0"
              >
                {{ getDaysAgo(item.AddedDate) }}
              </span>
            </div>
            <p class="text-[10px] text-slate-300 leading-snug break-words">
              {{ item.Notifications }}
            </p>
          </div>
        </div>

        <div
          *ngIf="isLoading"
          class="text-center text-[10px] text-slate-500 py-4 font-bold tracking-widest uppercase"
        >
          Loading feeds...
        </div>
      </div>
    </div>
  </div>
</div>
